import { render, staticRenderFns } from "./manualBinding.vue?vue&type=template&id=1afae950&scoped=true&"
import script from "./manualBinding.vue?vue&type=script&lang=js&"
export * from "./manualBinding.vue?vue&type=script&lang=js&"
import style0 from "./manualBinding.vue?vue&type=style&index=0&id=1afae950&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afae950",
  null
  
)

export default component.exports